'use client';

import { useState, type CSSProperties } from 'react';
import { useResolvedColorScheme } from '@/hooks/useResolvedColorScheme';
import {
  BREEDPLAN_IMAGE_DARK_STYLE,
  getBreedplanCopImageSrc,
} from './societyMemberFieldValue';

/**
 * Inline BREEDPLAN Herd Completeness of Performance star logo for grid cells.
 * Mirrors the detail page's SocietyMemberField15 rendering; falls back to the raw
 * rating code when the asset is missing.
 */
export function BreedplanCopBadge({ value }: { value: string }) {
  const [imageError, setImageError] = useState(false);
  const { isDarkMode } = useResolvedColorScheme();
  const src = getBreedplanCopImageSrc(value);

  if (!src || imageError) {
    return <>{value}</>;
  }

  const style: CSSProperties = {
    display: 'inline-block',
    verticalAlign: 'middle',
    maxHeight: 24,
    width: 'auto',
    ...(isDarkMode ? BREEDPLAN_IMAGE_DARK_STYLE : {}),
  };

  return (
    // eslint-disable-next-line @next/next/no-img-element -- static /public asset with an onError text fallback; next/image needs static dimensions
    <img
      src={src}
      alt={value}
      title={value}
      onError={() => setImageError(true)}
      style={style}
    />
  );
}
